import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import PageHeader from "./common/PageHeader";
import { Link } from "react-router-dom";

const PrivacyBody = () => {
  return (
    <>
      <br />

      <Container className="my-5">
        <PageHeader
          title="Privacy Policy for CONDOZAK™"
          description="Last Updated: March 01, 2025"
          className="mb-3"
          titleTag="h2"
        >
          <Link className="btn btn-sm btn-link ps-0" to="/contact-us">
            Have questions? Chat with us
          </Link>
        </PageHeader>
        <Row className="justify-content-center">
          <Col md={12}>
            <Card>
              <Card.Body>
                <h5 className="mb-2">1. Information We Collect</h5>
                <h6>
                  <b>Personal Information</b>
                </h6>
                <ul>
                  <li>Contact details: name, email address, phone number.</li>
                  <li>
                    Account credentials: username, password, security questions.
                  </li>
                  <li>
                    Property and unit information: ownership details, tenant
                    information, and property management records.
                  </li>
                  <li>
                    Payment details: credit card or banking information
                    (processed securely through third-party providers).
                  </li>
                </ul>
                <h6>
                  <b>Usage Information</b>
                </h6>
                <p>
                  We collect usage data, including logins, feature usage,
                  interaction history, and IP addresses.
                </p>

                <h6>
                  <b>Cookies and Tracking Technologies</b>
                </h6>
                <p>
                  We use cookies and similar technologies to improve user
                  experience, analyze usage patterns, and enhance security.
                </p>

                <h5>2. How We Use Your Information</h5>
                <ul>
                  <li>
                    Provide and improve CONDOZAK™ features and functionality.
                  </li>
                  <li>
                    Manage user accounts, authentication, and customer support.
                  </li>
                  <li>
                    Communicate with users regarding updates, support, and
                    administrative matters.
                  </li>
                  <li>
                    Ensure security and compliance, including fraud prevention.
                  </li>
                </ul>

                <h5>3. Sharing of Information</h5>
                <p>We may share your personal information with:</p>
                <ul>
                  <li>
                    Service providers and partners assisting us in operating and
                    maintaining CONDOZAK™.
                  </li>
                  <li>
                    Legal entities, if required by law or to protect our rights
                    and property.
                  </li>
                  <li>
                    Property management companies or condominium boards as
                    authorized by you.
                  </li>
                </ul>
                <p>
                  We do not sell or rent your personal information to third
                  parties.
                </p>

                <h5>4. Data Security</h5>
                <p>
                  We implement industry-standard security measures, including
                  encryption, access controls, and regular audits, to protect
                  your information from unauthorized access, alteration, or
                  disclosure.
                </p>

                <h5>5. Data Retention</h5>
                <p>
                  Your personal data is retained only as long as necessary to
                  fulfill purposes outlined in this policy, comply with legal
                  obligations, or resolve disputes.
                </p>

                <h5>6. Your Privacy Rights</h5>
                <p>You have the right to:</p>
                <ul>
                  <li>Access and rectify your personal information.</li>
                  <li>Request deletion or restriction of data processing.</li>
                  <li>
                    Withdraw consent previously given for processing your
                    personal data.
                  </li>
                </ul>
                <p>
                  Contact us to exercise your rights at{" "}
                  <a href="mailto:info@condozak.ca">info@condozak.ca</a>.
                </p>

                <h5>7. Children's Privacy</h5>
                <p>
                  CONDOZAK™ is not directed toward children under 16, and we do
                  not knowingly collect personal data from minors.
                </p>

                <h5>8. Changes to This Policy</h5>
                <p>
                  We may update this Privacy Policy periodically. We will notify
                  you of significant changes by email or through notifications
                  within CONDOZAK™.
                </p>

                <h5>9. Contact Information</h5>
                <p>
                  If you have questions or concerns regarding this Privacy
                  Policy or our privacy practices, contact us at:
                </p>
                <address>
                  {/* Truzak Technology Inc.
                  <br />
                  180 Northfield Drive West, Suite 4<br />
                  Waterloo, Ontario, N2L 0C7, Canada
                  <br /> */}
                  Email: <a href="mailto:info@condozak.ca">info@condozak.ca</a>
                </address>
                <hr />
                <p>
                  By using CONDOZAK™, you agree to the terms outlined in this
                  Privacy Policy.
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default PrivacyBody;
